import React from "react";
import { PiHourglassMediumFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

function PendingApproval() {
  const navigate = useNavigate();

  return (
    <div className="pending-page">
      <div className="pending-card">
        <div className="icon-container">
          <PiHourglassMediumFill className="pulse-icon" />
        </div>
        <h2>Account Under Review</h2>
        <p>
          Thank you for submitting your details. Our compliance team is currently 
          verifying your KYC information. 
        </p>
        <p className="sub-text">
          This process usually takes 24-48 hours. We will notify you via email once your account is approved.
        </p>
        <button onClick={() => navigate("/")} className="home-btn">
          Return to Home
        </button>
      </div>
    </div>
  );
}

export default PendingApproval;